import { CSSProperties } from 'react';

export const IMG_WRAP: CSSProperties = { position: 'relative', flexShrink: 0 };

export const CHECK_ICON: CSSProperties = {
  position: 'absolute',
  bottom: -4,
  right: -4,
  fontSize: 18,
  color: '#8dbc9a',
  background: '#fff',
  borderRadius: '50%',
};

export const TAG_STYLE: CSSProperties = {
  fontSize: 10,
  borderRadius: 4,
  margin: 0,
};

